export const POST_WEBKIT_ACTION = 'events/POST_WEBKIT_ACTION';

/**
 * @param payload
 * @returns {{payload: *, type: string}}
 */
export const postWebkitAction = (payload) => ({ type: POST_WEBKIT_ACTION, payload });
